import { SignedDocumentType } from '../types'

/**
 * Chứng từ ký số lập từ hoá đơn (MISA eSign). 2 loại dùng chung bộ API và component,
 * chỉ khác đường dẫn, tên field và vài tính năng. Tài liệu backend:
 * dc-api/modules/invoice/invoice.payment_request/FE_INTEGRATION.md (mục 10).
 */
export interface SignedDocumentConfig {
    type: SignedDocumentType
    /** /invoices/{id}/<path> */
    path: string
    /** Ký lô: /invoices/<batchPath>/sign */
    batchPath: string
    /** Field id trong response / items[] / history[] */
    idField: 'payment_request_id' | 'reconciliation_statement_id'
    /** Field trạng thái ở chi tiết + danh sách hoá đơn (+ _signed_at, _error ở danh sách), cũng là tên filter / sort */
    statusField: 'payment_request_status' | 'reconciliation_statement_status'
    signedAtField:
        | 'payment_request_signed_at'
        | 'reconciliation_statement_signed_at'
    errorField: 'payment_request_error' | 'reconciliation_statement_error'
    /** Trang "Hình ảnh" (image_source auto / upload + API images) */
    hasImages: boolean
    /** Gửi mail khách hàng (mail-prefill, send-mail) */
    hasMail: boolean
    /** Tên file tải về (backend đặt qua file_download_url) */
    fileName: (invoiceID: number) => string
    /** Key i18n (namespace invoice) dạng `signed-document.<type>.*` */
    i18nKey: string
}

export const SIGNED_DOCUMENTS: Record<
    SignedDocumentType,
    SignedDocumentConfig
> = {
    'payment-request': {
        type: 'payment-request',
        path: 'payment-request',
        batchPath: 'payment-requests',
        idField: 'payment_request_id',
        statusField: 'payment_request_status',
        signedAtField: 'payment_request_signed_at',
        errorField: 'payment_request_error',
        hasImages: false,
        hasMail: true,
        fileName: (id) => `giay-de-nghi-thanh-toan-HD-${id}.pdf`,
        i18nKey: 'signed-document.payment-request',
    },
    'reconciliation-statement': {
        type: 'reconciliation-statement',
        path: 'reconciliation-statement',
        batchPath: 'reconciliation-statements',
        idField: 'reconciliation_statement_id',
        statusField: 'reconciliation_statement_status',
        signedAtField: 'reconciliation_statement_signed_at',
        errorField: 'reconciliation_statement_error',
        hasImages: true,
        hasMail: true,
        fileName: (id) => `bien-ban-doi-soat-HD-${id}.pdf`,
        i18nKey: 'signed-document.reconciliation-statement',
    },
}

/** Thứ tự hiện trên chi tiết / danh sách hoá đơn */
export const SIGNED_DOCUMENT_TYPES: SignedDocumentType[] = [
    'payment-request',
    'reconciliation-statement',
]

/** Tên cột / filter trạng thái chứng từ ở danh sách hoá đơn (để ẩn ở tab không có chứng từ) */
export const SIGNED_DOCUMENT_STATUS_FIELDS: string[] =
    SIGNED_DOCUMENT_TYPES.map((type) => SIGNED_DOCUMENTS[type].statusField)
